import i18next from "i18next";
import Cookie from "modules/Cookie/Cookie";
import HtmlInFrame from "modules/HtmlInFrame/HtmlInFrame";
import useAppStore from "store/store";

interface PageCardProps {
    html: string;
    htmlData?: any;
}

const PageCard = ({ html, htmlData }: PageCardProps) => {

    const isPreview = useAppStore((state) => state.isPreview);

    return (
        <>
            { isPreview && (
                <div className="preview-banner">
                    <h1>{ i18next.t('preview.text') }</h1>
                </div>
            )}

            <HtmlInFrame
                html={html}
                htmlData={htmlData}
            />

            <Cookie />
        </>
    )
}

export default PageCard;